/**
 * VERICAP — MUI COLOUR PALETTE
 * packages/ui/mui/Theme/base/colors.ts
 *
 * ALL VALUES MUST BE HEX. No CSS vars here, ever.
 * MUI calls decomposeColor() on palette values — CSS vars break it.
 *
 * CSS vars live in globals.css and are used in sx props / plain CSS.
 * To update a colour: change it here AND in globals.css :root.
 */

const colors = {
  brand: {
    main: "#6E3FD4", // --vc-violet
    hover: "#5C2FBF", // --vc-violet-hover
    pressed: "#4A1FA8", // --vc-violet-pressed
    medium: "#A989F5", // --vc-violet-light
    light: "#EDE8FD", // --vc-violet-tint
    disabled: "#F0ECFC", // --vc-violet-subtle
  },

  background: {
    default: "#FFFFFF", // --vc-bg
    secondary: "#F3F4F6", // --vc-bg-secondary
    tertiary: "#E1E4E8", // --vc-border (used as bg in some places)
    cell1: "#FFFFFF",
    cell2: "#F9FAFD",
    SideNav: "#FFFFFF", // --vc-bg-sidenav
    dark: "#111827", // --vc-bg-dark
    page: "#F4F5F7", // --vc-bg-page
  },

  border: {
    main: "#E1E4E8", // --vc-border
    disabled: "#FFFFFF",
    selected: "#9CA3AF", // --vc-border-strong
    medium: "#C9CDD4", // --vc-border-medium
    dark: "#9CA3AF",
    brand: "#6E3FD4", // --vc-violet
  },

  text: {
    main: "#111827", // --vc-text-primary
    secondary: "#374151", // --vc-text-secondary
    tertiary: "#4B5563", // --vc-text-tertiary
    disabled: "#9CA3AF", // --vc-text-disabled
    labelWhite: "#FFFFFF",
    labelBrand: "#6E3FD4", // --vc-violet
    error: "#DE1135", // --vc-error
  },

  // These use Vericap's semantic status colours (not MUI defaults)
  // MUI processes .main values — must be hex
  warning: {
    main: "#92400E", // --vc-needs-fix (deep amber)
    medium: "#FEF3C7", // --vc-needs-fix-bg
    light: "#FEF3C7",
    border: "#FCD34D",
  },

  success: {
    main: "#166534", // --vc-approved (deep green)
    medium: "#DCFCE7", // --vc-approved-bg
    light: "#DCFCE7",
    border: "#86EFAC",
  },

  error: {
    main: "#DE1135", // --vc-error (keep original error colour here)
    medium: "#FEE2E2",
    disabled: "#FEE2E2",
    border: "#FCA5A5",
  },

  info: {
    main: "#1E40AF", // --vc-review (deep blue)
    medium: "#DBEAFE", // --vc-review-bg
    light: "#DBEAFE",
    border: "#93C5FD",
  },

  // Platform-specific status colours
  // Use these directly in components: colors.status.approved etc.
  status: {
    approved: "#166534",
    approvedBg: "#DCFCE7",
    approvedBorder: "#86EFAC",

    needsFix: "#92400E",
    needsFixBg: "#FEF3C7",
    needsFixBorder: "#FCD34D",

    missing: "#991B1B",
    missingBg: "#FEE2E2",
    missingBorder: "#FCA5A5",

    review: "#1E40AF",
    reviewBg: "#DBEAFE",
    reviewBorder: "#93C5FD",

    uploaded: "#0F766E",
    uploadedBg: "#CCFBF1",
    uploadedBorder: "#5EEAD4",

    pending: "#374151",
    pendingBg: "#F3F4F6",
    pendingBorder: "#9CA3AF",

    flagged: "#7F1D1D",
    flaggedBg: "#FEE2E2",
    flaggedBorder: "#F87171",

    draft: "#374151",
    draftBg: "#F3F4F6",
    draftBorder: "#9CA3AF",
  },
};

export default colors;
